import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EnrichmentIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Enrichment",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m5.31 6.79 1.19 2.2c.34.61.82 1.1 1.43 1.44l2.18 1.2-2.18 1.2c-.61.34-1.09.83-1.43 1.44l-1.19 2.2-1.19-2.2c-.34-.61-.82-1.1-1.43-1.44l-2.18-1.2 2.18-1.2c.61-.34 1.09-.83 1.43-1.44zM13.74 3.62l.8 1.48c.23.41.55.74.96.97l1.47.81-1.47.81c-.41.23-.74.56-.96.97l-.8 1.48-.8-1.48c-.23-.41-.55-.74-.96-.97l-1.47-.81 1.47-.81c.41-.23.74-.56.96-.97zM31.31 12.75c.24.22.26.59.04.84L18.3 28.19a.58.58 0 0 1-.84.03l-8.14-7.88a.607.607 0 0 1-.02-.84l2.31-2.42c.23-.24.6-.24.83-.02l5.22 5.05L28 10.54c.22-.24.59-.26.83-.04z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15 15c-3.31 0-6-2.69-6-6 0 3.31-2.69 6-6 6 3.31 0 6 2.69 6 6 0-3.31 2.69-6 6-6"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9 22c-.55 0-1-.45-1-1 0-2.76-2.24-5-5-5-.55 0-1-.45-1-1s.45-1 1-1c2.76 0 5-2.24 5-5 0-.55.45-1 1-1s1 .45 1 1c0 2.76 2.24 5 5 5 .55 0 1 .45 1 1s-.45 1-1 1c-2.76 0-5 2.24-5 5 0 .55-.45 1-1 1m-2.4-7c.98.59 1.81 1.42 2.4 2.4.59-.98 1.42-1.81 2.4-2.4A7.07 7.07 0 0 1 9 12.6c-.59.98-1.42 1.81-2.4 2.4M24 9c-2.21 0-4 1.79-4 4 0-2.21-1.79-4-4-4 2.21 0 4-1.79 4-4 0 2.21 1.79 4 4 4"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20 14c-.55 0-1-.45-1-1 0-1.65-1.35-3-3-3-.55 0-1-.45-1-1s.45-1 1-1c1.65 0 3-1.35 3-3 0-.55.45-1 1-1s1 .45 1 1c0 1.65 1.35 3 3 3 .55 0 1 .45 1 1s-.45 1-1 1c-1.65 0-3 1.35-3 3 0 .55-.45 1-1 1m-1-5c.38.29.72.62 1 1 .29-.38.62-.72 1-1-.38-.29-.72-.62-1-1-.29.38-.62.72-1 1M21 27c-.26 0-.51-.1-.71-.29l-4-4a.996.996 0 1 1 1.41-1.41l3.29 3.29 7.29-7.29a.996.996 0 1 1 1.41 1.41l-8 8c-.2.2-.45.29-.71.29Z"
      })]
    })
  }));
};